import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/talents";

const talentApi = {
  talentList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getSummaryTalent(params: any): Promise<any> {
    const url = `${path}/summaries`;
    return api.get(url, params);
  },

  getTalentDetail(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  postTalent(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putTalent(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  updateStatusTalent(dataForm: any): Promise<any> {
    const url = `${path}/is-active`;
    return api.put(url, dataForm);
  },

  updateVisibleRecruitmentTalent(dataForm: any): Promise<any> {
    const url = `${path}/is-visible-in-recruitment`;
    return api.put(url, dataForm);
  },

  deleteTalent(id: any) {
    return api.delete(`${path}/${id}`);
  },
};


export default talentApi;
